export const PHONE_PREFIXES = ["0412", "0414", "0416", "0422", "0424", "0426"];
